module.exports = __webpack_public_path__ + "img/honor_sg_001.e293216.png";